var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: "400", eager: "" },
      model: {
        value: _vm.open,
        callback: function($$v) {
          _vm.open = $$v
        },
        expression: "open"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-combobox", {
                        attrs: {
                          label: `${_vm.value.id} Units`,
                          items: _vm.unitList,
                          multiple: "",
                          chips: "",
                          "hide-details": "",
                          "item-value": "id",
                          "item-text": "id",
                          "error-messages":
                            _vm.stockCategoryUnitStorePostErrors.units
                        },
                        on: { change: _vm.unitChange },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function({ item, index, selected }) {
                              return [
                                _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      color: "blue-grey darken-3",
                                      dark: "",
                                      "input-value": selected,
                                      label: "",
                                      small: ""
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "mr-2" }, [
                                      _vm._v(_vm._s(item.id || item))
                                    ]),
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: { small: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteItem(index)
                                          }
                                        }
                                      },
                                      [_vm._v("$delete")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          },
                          {
                            key: "item",
                            fn: function({ item }) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "mr-2 primary--text" },
                                  [_vm._v(_vm._s(item.id))]
                                ),
                                _c(
                                  "small",
                                  { staticClass: "blue-grey--text" },
                                  [_vm._v(_vm._s(item.description || "N/A"))]
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.unit,
                          callback: function($$v) {
                            _vm.unit = $$v
                          },
                          expression: "unit"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("base-snackbar", {
        attrs: { errors: _vm.stockCategoryUnitStorePostErrors },
        on: {
          "update:errors": function($event) {
            _vm.stockCategoryUnitStorePostErrors = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }